import { type DisplayField } from '@wix/ambassador-forms-v2-form-template/types';

const ContentKey = 'content';
const MaxShownParagraphsKey = 'maxShownParagraphs';

import { type FieldsDisplayField as PlatformizedDisplayField } from '@wix/ambassador-forms-v4-form/types';

export function makeViewOfDisplayProperties(
  displayField: DisplayField | PlatformizedDisplayField,
): object {
  if (displayField.richContentOptions) {
    return {
      [ContentKey]: displayField.richContentOptions?.richContent,
      [MaxShownParagraphsKey]:
        displayField.richContentOptions?.maxShownParagraphs,
    };
  }
  const pageNavigation = displayField.pageNavigationOptions;
  if (pageNavigation) {
    return {
      ...(pageNavigation.submitText
        ? { submitText: pageNavigation.submitText }
        : {}),
      ...(pageNavigation.nextPageText
        ? { nextText: pageNavigation.nextPageText }
        : {}),
      ...(pageNavigation.previousPageText
        ? { previousText: pageNavigation.previousPageText }
        : {}),
    };
  }
  return {};
}
